"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Container = exports.Title = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Image = _interopRequireDefault(require("../Image"));

var _withOptionalLink = _interopRequireDefault(require("../HOC/withOptionalLink"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Typography = require("../Typography");

var _Layout = require("../Layout");

var GridImage = (0, _styled.default)(_Image.default)(function (_ref) {
  var height = _ref.height;
  return _defineProperty({
    maxHeight: '10rem',
    maxWidth: '100%'
  }, _mediaQueries.default.small, {
    maxHeight: height
  });
});
var Title = (0, _styled.default)(_Typography.PageTitle)(function (_ref3) {
  var titleColour = _ref3.titleColour,
      _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      imageGrid = _ref3$theme.imageGrid,
      colors = _ref3$theme.colors;
  return {
    textAlign: imageGrid.titleAlign,
    marginBottom: space.large,
    color: colors[titleColour]
  };
});
exports.Title = Title;
var Container = (0, _styled.default)(_Layout.Container)(function (_ref4) {
  var backgroundColour = _ref4.backgroundColour,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      space = _ref4$theme.space;
  return {
    paddingTop: space.base,
    paddingBottom: space.base,
    backgroundColor: colors[backgroundColour]
  };
});
exports.Container = Container;

var _default = (0, _withOptionalLink.default)(GridImage);

exports.default = _default;